import { TObjectValidationScheme } from '@krugom/validator/dist/types';
import { isBoolean, isString } from 'lodash';

export const baseInputValidationScheme: TObjectValidationScheme = {
  type: 'object',
  required: true,
  properties: {
    name: {
      type: 'string',
      required: true,
    },
    required: {
      type: 'boolean',
    },
    formOnly: {
      type: 'boolean',
    },
    validation: {
      type: 'array',
      itemScheme: {
        type: 'object',
        properties: {
          isWrongMessage: {
            type: 'string',
            required: true,
          },
          isWrong: {
            type: 'custom',
            validator: value => isString(value) || isBoolean(value),
          },
        },
      },
    },
  },
};
